<template>
    <p class="my-2">Il s'agit des types de marchandises que vous transportez</p>
    <button type="button" class="btn btn-sm btn-outline-dark mb-3" @click="openCreateModal()">
        <i class="fas fa-plus"></i> Nouveau type
    </button>

    <DataTableBackend :url="'/api/'+table" :columns="columns" :table="table" :perPage="6">
        <template #action_btns=slotProps>
            <button class="btn btn-sm btn-light m-1" @click="openShowModal(slotProps.data)">
                <i class="fa-solid fa-ellipsis"></i>
            </button>
        </template>
    </DataTableBackend>
</template>
    
<script >
import CreateTypeMarchandise from './CreateTypeMarchandise.vue'
import ShowTypeMarchandise from './ShowTypeMarchandise.vue'

export default {
    name: 'IndexTypeMarchandise',
    data() {
        return {
            table: 'types_marchandises',
            baseUrl: this.$store.state.api_yams_livraisons,
            isLoading: false,
            columns: [
                {
                    key: 'id',
                    label: 'ID',
                },
                {
                    key: 'libelle',
                    label: 'Nom',
                    exportable: true
                }
            ]
        }
    },
    methods: {
        openCreateModal() {
            this.$dialog.open(CreateTypeMarchandise, {
                props: {
                    header: "Nouveau service",
                    style: {
                        width: '20vw'
                    },
                    modal: true
                }
            });
        },
        openShowModal(objData) {
            this.$dialog.open(ShowTypeMarchandise, {
                props: {
                    header: "Service N°"+objData.id,
                    style: {
                        width: '20vw'
                    },
                    modal: true
                },
                data: objData
            });
        }
    }
}
</script>
    